import React from "react";
import { Hash, Package } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { FieldLabel, RadioCard, SectionLabel } from "./FormPrimitives";

export const PackagesCard = ({ form, setField }) => (
  <Card className="border-zinc-200 shadow-sm">
    <div className="p-6 md:p-8">
      <SectionLabel hint="Step 5 / 5">Package Numbering</SectionLabel>
      <div className="grid grid-cols-2 gap-3 mb-4">
        <RadioCard
          testid="radio-pkg-auto"
          checked={form.package_mode === "auto"}
          onClick={() => setField("package_mode", "auto")}
          icon={Package}
          label="Automatic"
          sublabel="Generate 1/N…N/N"
        />
        <RadioCard
          testid="radio-pkg-manual"
          checked={form.package_mode === "manual"}
          onClick={() => setField("package_mode", "manual")}
          icon={Hash}
          label="Manual"
          sublabel="Enter number"
        />
      </div>

      {form.package_mode === "auto" ? (
        <div>
          <FieldLabel htmlFor="package_total">Total Number of Packages</FieldLabel>
          <Input
            id="package_total"
            data-testid="input-package-total"
            type="number"
            min="1"
            value={form.package_total}
            onChange={(e) => setField("package_total", e.target.value)}
            className="h-11 font-mono w-full md:w-48"
          />
          <p className="text-[11px] text-zinc-500 mt-2 font-mono">
            PDF will contain {Math.max(1, Number(form.package_total) || 1)} page(s) → 1/{form.package_total}, 2/{form.package_total}…
          </p>
        </div>
      ) : (
        <div>
          <FieldLabel htmlFor="label_number">Label Number (optional reference)</FieldLabel>
          <Input
            id="label_number"
            data-testid="input-label-number"
            placeholder="e.g. L-2026-0042"
            value={form.label_number}
            onChange={(e) => setField("label_number", e.target.value)}
            className="h-11 font-mono w-full md:w-64"
          />
          <p className="text-[11px] text-zinc-500 mt-2 font-mono">
            Only the line <span className="font-bold">Package No : ____ ___/___ ____</span> appears on the label, leaving blanks for hand-writing.
          </p>
        </div>
      )}
    </div>
  </Card>
);
